import { render, staticRenderFns } from "./VatInvoiceExcelV2.vue?vue&type=template&id=4ddd953e"
import script from "./VatInvoiceExcelV2.vue?vue&type=script&lang=js"
export * from "./VatInvoiceExcelV2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports